import { IconProps, iconA11yProps } from '../types';

export const AltText = ({ classNames, label }: IconProps) => (
    <svg
        className={`${classNames}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...iconA11yProps(label)}
    >
        <path d="M4 16v-6a2 2 0 1 1 4 0v6" />
        <path d="M4 13h4" />
        <path d="M11 8v8h4" />
        <path d="M16 8h4" />
        <path d="M18 8v8" />
    </svg>
);
